import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import ProductDescription from '../../components/ProductDescription/ProductDescription';
import ProductDonation from '../../components/ProductDonation/ProductDonation';
import ProductNotes from '../../components/ProductNotes/ProductNotes';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { appStore } from 'src/mobx/appStore';
import { PRODUCT_TYPE } from 'src/types/product';
import { IResponseProductSize } from 'src/types/products';
import Sizes, { IPickerSize } from 'src/view/components/Controls/Sizes/Sizes';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';

const ProductInfoBlock: React.FC = observer((): JSX.Element => {
  const { product } = orderProductModalStore;

  const isMeal = useMemo((): boolean => product?.type === PRODUCT_TYPE.MEAL_COMBO, [product?.type]);

  const mealSizes = useMemo((): IPickerSize<IResponseProductSize>[] => {
    if (!product) return [];

    return product.sizes.reduce((sum: IPickerSize<IResponseProductSize>[], current) => {
      if (product?.items?.some((item) => item.size_id === current.id)) {
        sum.push({ value: current, name: current.name, key: current.id });
      }

      return sum;
    }, []);
  }, [product]);

  return (
    <ScrollableBlock
      showScrollbar
      scrollbarSize="small"
      className={classNames('product-block', { 'mt-8 mx-6': !product?.type, 'mt-4 mb-6': product?.type })}
      scrollClassName={classNames('full-height', { 'justify-content-between px-6 px-lg-5': product?.type })}
    >
      <div className="d-flex flex-column">
        <h2 className="product-info-block__name mb-4">{orderProductModalStore.product?.name || <Skeleton width="70%" />}</h2>

        {isMeal ? (
          <Sizes
            selected={orderProductModalStore.product?.size?.id}
            options={mealSizes}
            onChange={orderProductModalStore.onChangeSize}
            className="mb-6"
          />
        ) : null}

        <ProductDonation />
        <ProductDescription />
      </div>

      {appStore.settings?.item_notes ? <ProductNotes /> : null}
    </ScrollableBlock>
  );
});

export default ProductInfoBlock;
